/** @jsx jsx */
import React, { useEffect } from 'react';
import FormSubmitArea from 'components/atoms/Form/FormSubmitArea';
import Button from 'components/atoms/Button';
import FormLabel from 'components/atoms/Form/FormLabel';
import FlexBox from 'components/atoms/FlexBox';
import {
  grayScale,
} from 'components/styles';
import DataTable from 'components/organismos/DataTable/DataTable';
import { css, jsx } from '@emotion/core';
import Accordion from 'components/molecules/Accordion';
import SpecialHolidayGrantHistoryDomain from 'domain/master/holidayManagement/specialHolidayGrantHistory';
import { Column } from 'react-table';
import DatePicker from 'components/molecules/DatePicker';
import OrganizationFilteredTree from 'components/organismos/organization/OrganizationFilteredTree/OrganizationFilteredTree';
import { useSpecialHolidayGrantHistoryDomainForm, useDownloadHolidayManagementSpecialHolidayGrantHistory } from './hooks';
import useCurrentRoleScreen from 'hooks/useCurrentRoleScreen';

// create style form
const styles = {
  form: css({
    paddingTop: '15px',
  }),
  wrapper: css({
    display: 'flex',
    width: '150px',
    float: 'left',
  }),
  container: css({
    padding: '4px 0',
  }),
  label: css({
    flexBasis: '100px',
  }),
  select: css({
    flexGrow: 4,
    minWidth: '100px',
  }),
  digestionDays: css({
    width: '200px',
  }),
  betweenDays: css({
    width: '50px',
    textAlign: 'center',
  }),
  textMessage: css({
    color: 'black',
  }),
};

const GrantHistoryForm: React.FC<
{
  arrGrantResult: any,
  currentAccordionList: any,
  setCurrentAccordionList: any
}> = (
  {
    arrGrantResult,
    currentAccordionList,
    setCurrentAccordionList,
  },
) => {
  const {
    paidHolidayGrantHistoryList,
    orgCode,
    setOrgCode,
    targetDateFrom,
    setTargetDateFrom,
    targetDateTo,
    setTargetDateTo,
  } = useSpecialHolidayGrantHistoryDomainForm();

  const {
    downloadHolidayManagementSpecialHolidayGrantHistory,
  } = useDownloadHolidayManagementSpecialHolidayGrantHistory(
    orgCode,
    targetDateFrom,
    targetDateTo,
  );
  //
  const columns: Array<Column<SpecialHolidayGrantHistoryDomain>> = React.useMemo(() => [
    {
      Header: 'スタッフコード',
      accessor: 'staffCode',
      sortType: 'basic'
    },
    {
      Header: 'スタッフ名',
      accessor: 'staffName',
    },
    {
      Header: '休暇名',
      accessor: 'holidayName',
    },
    {
      Header: '付与日',
      accessor: 'grantDate',
    },
    {
      Header: '付与種別',
      accessor: 'grantTypeStr',
    },
    {
      Header: '付与日数',
      accessor: 'grantDaysNumStr',
    },
    {
      Header: '前回消化日数',
      accessor: 'lastDigestedDaysNumStr',
    },
    {
      Header: '前回消滅日数',
      accessor: 'lastExtinctionDaysNumStr',
    },
  ], []);
  const staffCode = sessionStorage.getItem('loginUser.staffCode') || '';
  const accessLevel = sessionStorage.getItem('loginUser.accessLevel');
  const managementOrg = 5;


  // Check prototype role staff
  const roleScreen = useCurrentRoleScreen('/attendHolidayManagement');

  const staffAccess = roleScreen && roleScreen.useStaffAccess === true && (roleScreen.staffAccessFunctionRoles || []).filter((role: any) => role.orgCode === orgCode);

  const checkUserRole = orgCode !== 'all' && staffAccess && staffAccess.length > 0 ? staffAccess[0] : roleScreen;


  return (
    <Accordion
      text="付与履歴"
      color={grayScale.gray100}
      callBack={() => {}}
      defaultExpand={!!((sessionStorage.getItem('attendHolidayManagement.accordion.specialHoliday.grandhistory') === String(true)))}
      accordionValue="specialHoliday.grandhistory"
    >
      <div>
        <div css={styles.container}>
          <FlexBox>
            <div css={styles.label}>
              <FormLabel
                label="付与日"
              />
            </div>
            <div css={styles.digestionDays}>
              <DatePicker
                dateFormat="yyyy年MM月dd日"
                date={targetDateFrom}
                changeDate={(date: Date) => {
                  if (date !== null) {
                    setTargetDateFrom(date);
                    sessionStorage.setItem('specialHoliday.grandHistory.targetDateFrom', String(date));
                  }
                  sessionStorage.setItem('specialHoliday.grandHistory.targetDateFrom', String(date));
                }}
                isFullWidth={true}
              />
            </div>
            <div css={styles.betweenDays}>
              ～
            </div>
            <div css={styles.digestionDays}>
              <DatePicker
                dateFormat="yyyy年MM月dd日"
                date={targetDateTo}
                changeDate={(date: Date) => {
                  if (date !== null) {
                    setTargetDateTo(date);
                    sessionStorage.setItem('specialHoliday.grandHistory.targetDateTo', String(date));
                  }
                  sessionStorage.setItem('specialHoliday.grandHistory.targetDateTo', String(date));
                }}
                isFullWidth={true}
              />
            </div>
          </FlexBox>
        </div>

        <OrganizationFilteredTree
          functionType={2}
          staffCode={staffCode}
          orgLabel="組織名"
          initOrgValue={String(orgCode)}
          orgCallback={(args: string | Array<string>) => {
            setOrgCode(String(args));
          }}
          targetdayForm={targetDateFrom}
          targetdayTo={targetDateTo}
          addAllItem={false}
          apiVersion="v6"
          menuId={roleScreen?.menuId}
          styles={{
            label: {
              toggleSwitch: css({ marginLeft: '0px' }),
            },
            toggle: {
              width: '13rem',
            },
          }}
          orgFilter={managementOrg}
        />
        <div
          css={css`
              table th:nth-child(1) {
                width: 140px;
              }
              table th:nth-child(2) {
                width: 100px;
              }
              table th:nth-child(3) {
                width: 100px;
              }
              table th:nth-child(4) {
                width: 140px;
              }
              table th:nth-child(5) {
                width: 100px;
              }
              table th:nth-child(6) {
                width: 80px;
              }
              table th:nth-child(7) {
                width: 100px;
              }
              table th:nth-child(8) {
                width: 100px;
              }
            `}
        >

          <div style={{ overflowX: 'auto', whiteSpace: 'nowrap' }}>
            <DataTable
              columns={columns}
              data={paidHolidayGrantHistoryList}
              isGlobalFilter={true}
              minWidth="924px"
              sortBy={[
                { id: 'staffCode', desc: false }
              ]}
            />
          </div>
        </div>
        <FormSubmitArea>
          <div style={{ marginRight: '12px' }}>
            {checkUserRole && checkUserRole.downloadFlag === 1 && (
            <Button
              text="ダウンロード  "
              onClick={() => downloadHolidayManagementSpecialHolidayGrantHistory()}
            />
            )}
          </div>
          {Number(accessLevel) === 1 && checkUserRole && checkUserRole.downloadFlag === 1 && (
          <Button
            text="全店舗ダウンロード "
            onClick={() => downloadHolidayManagementSpecialHolidayGrantHistory(true)}
          />
          )}

        </FormSubmitArea>
      </div>
    </Accordion>
  );
};
export default GrantHistoryForm;
